import { DeepReadonly } from 'utility-types';

export type TempSharingSettingsState = DeepReadonly<{
  permissionGroup?: string;
  isPortfolioOn?: boolean;
}>;

export const INITIAL_STATE: TempSharingSettingsState = {};
